// ***************** Componente BuscaCidade **************
// **** "\src\app\AgendexCliente\components\Busca\buscacidade.jsx"
// **** autor: W de Paula /MVinfo
// **** data: 05/06/24 | 16h04
// **** todos os direitos reservados. proibida a cópia, reprodução, plágio em parte ou no todo
// ****   sem a expressa e plena autorização do autor. Sujeito às punições severas da lei.
// ***************** Componente BuscaCidade **************



import { useState, useEffect } from 'react';
import { decrypt } from '../../../../Services/cryptoUtils';
import './busca.css';

function BuscaCidade({ onCidadePesquisada }) {
    const encryptedUser = localStorage.getItem('tokenacw');
    const decryptedUser = decrypt(encryptedUser);
    // console.log('Decrypted User:', decryptedUser);

    const [usu_cidade, setUsu_Cidade] = useState(decryptedUser ? decryptedUser.cidade : '');
    const [cidade, setCidade] = useState(usu_cidade);
    const [buscaCidadeAtiva, setBuscaCidadeAtiva] = useState(
        JSON.parse(localStorage.getItem('buscaCidade')) || false
    );

    useEffect(() => {
        const handleStorageChange = () => {
            setBuscaCidadeAtiva(JSON.parse(localStorage.getItem('buscaCidade')));
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const handlePesquisar = () => {
        const cidadeMaiuscula = cidade.toUpperCase();
        if (cidadeMaiuscula) {
            localStorage.setItem('buscaCidade', false);
            setBuscaCidadeAtiva(false);
            onCidadePesquisada(cidadeMaiuscula);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handlePesquisar();
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-5">
                    <h5>Agende os seus serviços</h5>
                </div>
                <div className="col-md-7">
                    <div className="input-group mb-3 input-group-mobile">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Digite a cidade que você deseja pesquisar..."
                            disabled={!buscaCidadeAtiva}
                            value={cidade}
                            onChange={(e) => setCidade(e.target.value)}
                            onKeyPress={handleKeyPress}
                            aria-describedby="button-addon2"
                        />
                        <button
                            className="btn btn-outline-danger"
                            type="button"
                            id="button-busca-cidade"
                            onClick={handlePesquisar}
                            disabled={!buscaCidadeAtiva}
                        >
                            <i className="fas fa-search">Pesquisar</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BuscaCidade;
